import { APIS, URLS } from '@/shared/config/urls';
// import { reqDelete, reqGet, reqPost, reqPut } from "@/utils/request";
import { request } from '@/shared/utils/request';
import type {
  CreateDetectionRequest,
  CreateDetectionResponse,
  DeleteDetectionResponse,
  DetectionDetailResponse,
  DetectionListResponse,
  SiteRoadResponse,
  UpdateDetectionRequest,
  UpdateDetectionResponse,
} from '../types/event-management.types';

// [GET] Detection List
export const fetchDetectionList = async (params = ''): Promise<DetectionListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detectionList(params)}`;
  return await request.get(url);
};

// [GET] Detection Detail
export const fetchDetectionDetail = async (
  detectionID: string | number
): Promise<DetectionDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailDetection(detectionID.toString())}`;
  return await request.get(url);
};

// [PUT] Update Detection
export const updateDetection = async (
  detectionID: string | number,
  detectionData: UpdateDetectionRequest
): Promise<UpdateDetectionResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateDetection(detectionID.toString())}`;
  return await request.put(url, detectionData);
};

// [POST] Create Detection
export const createDetection = async (
  detectionData: CreateDetectionRequest
): Promise<CreateDetectionResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createDetection}`;
  return await request.post(url, detectionData);
};

// [DELETE] Delete Detection
export const deleteDetection = async (
  detectionID: string | number
): Promise<DeleteDetectionResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteDetection(detectionID.toString())}`;
  return await request.delete(url);
};

export const fetchSiteRoad = async (params = ''): Promise<SiteRoadResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.siteRoad(params)}`;
  return await request.get(url);
};
